import { render, staticRenderFns } from "./ProjectValuationBuyers.vue?vue&type=template&id=09bb4e30&"
import script from "./ProjectValuationBuyers.vue?vue&type=script&lang=ts&"
export * from "./ProjectValuationBuyers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports